<app-homepage-header pageName="{{'products_content.product_details' | translate}}"></app-homepage-header>

<section class="section-wrapper-mb mt-150px mb-5">
  <div class="flex-direction-column product-details-left i-width-100 m-0">
    <img class="product-details-left-img" [src]="getProductImageUrl(product.imageUrls[0])" alt="card">

    @if (product.imageUrls.length > 1) {
      <div class="pictures-scroll-container i-width-100">
        @for (pic of product.imageUrls; track pic) {
          <div class="picture-item">
            <img
              [src]="getProductImageUrl(pic)"
              [class.selected]="pic === selectedImage"
              (click)="changeSelectedImage(pic)"
              alt="thumbnail">

          </div>
        }
      </div>
    }
  </div>

  <div class="flex-direction-column mt-30px">
    <span class="product-name my-2">{{ product.productName }}</span>
    <span class="product-price">
        ${{ totalPriceUSD | number:'1.1-1' }} / {{ totalPriceAMD }}
      <span style="font-size: 14px;">{{ 'subscription_plan_content.AMD' | translate }}</span>
      </span>
    <span class="product-description-headline mt-20px">{{ 'products_content.description' | translate }}</span>
    <span class="product-details-text" [innerHTML]="product.productDescription"></span>

    <div class="mt-2">
      @if (product.compatibilityDescription) {
        <span class="product-description-headline mt-20px">
        {{ 'products_content.compatibility' | translate }}
      </span>
        <div class="mt-2">
          <span class="product-details-text" [innerHTML]="product.compatibilityDescription"></span>
        </div>
      }
    </div>
    <div class="my-1 cursor-pointer">
      @for (attribute of product.attributeValues; track attribute) {
        <div class="color-box mx-2"
             [class.selected]="selectedColor === attribute.id"
             [style.background-color]="attribute.value"
             (click)="selectColor(attribute)">
        </div>
      }
    </div>
    <div class="quantity-selector">
      <button (click)="decreaseQuantity()" [disabled]="quantity <= 1">&minus;</button>
      <span>{{ quantity }}</span>
      <button (click)="increaseQuantity()">&plus;</button>
    </div>

    <div class="flex-direction-column mt-30px mb-4">
      <button class="filled-button tall-button mobile-button"
              (click)="quickShop()">{{ 'products_content.quick_shop' | translate }}
      </button>
      <div class="flex-direction-row align-items-center mt-10px"
           [class]="product.isAddedToCart ? 'justify-content-between' : ''">
        <button class="text-button tall-button mobile-button"
                [class]="product.isAddedToCart ? 'width-90 selected-cart-button' : ''"
                (click)="addToCart()">
          {{ 'products_content.add_to_cart' | translate }}
        </button>
        @if (product.isAddedToCart) {
          <img class="selected-card-icon" src="assets/svg/selected.svg" alt="selected">
        }
      </div>
    </div>
  </div>
</section>

<app-footer></app-footer>
